// extracted by mini-css-extract-plugin
export default {"image":"LXImage_image__0A-jW","imageSVG":"LXImage_imageSVG__GNJkM"};